<form [formGroup]="mform" (ngSubmit)="onSubmit()" class="login-container w-full">

  <div *ngIf="true" class="bg-white rounded-xl p-6 shadow-md">

    <div class="user-group grid grid-cols-12 border-t-2 pt-4 px-6 gap-8">



      <!-- Machine Name -->
      <div class="col-span-6">
        <mat-label>Machine Name </mat-label>

        <mat-form-field appearance="outline" class="w-full ">
          <input matInput formControlName="equipment_name" />
          <mat-error *ngIf="submitted && f['equipment_name'].errors?.['required']">
            Machine Name is required
          </mat-error>
        </mat-form-field>
      </div>


      <!-- Machine Name -->
      <div class="col-span-6">
        <mat-label>Machine Code </mat-label>

        <mat-form-field appearance="outline" class="w-full ">
          <input matInput formControlName="equipment_code" />
          <mat-error *ngIf="submitted && f['equipment_code'].errors?.['required']">
            Machine is required
          </mat-error>
        </mat-form-field>
      </div>


      <!-- Machine Brand -->
      <div class="col-span-6">
        <mat-label>Category </mat-label>

        <mat-form-field appearance="outline" class="w-full ">
          <mat-select formControlName="category">
            <mat-option value="" disabled>Select Machine Type</mat-option>
            <mat-option *ngFor="let type of machineCategories" [value]="type.id">{{ type.name }}</mat-option>
          </mat-select>

          <mat-error *ngIf="submitted && f['category'].errors?.['required']">
            Category is required
          </mat-error>
        </mat-form-field>
      </div>




      <!-- Machine Model -->
      <div class="col-span-6">
        <mat-label>Capacity </mat-label>

        <mat-form-field appearance="outline" class="w-full ">
          <input matInput formControlName="capacity" />
          <mat-error *ngIf="submitted && f['capacity'].errors?.['required']">
            Capacity is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-span-6">
        <mat-label>Machine Specification </mat-label>

        <mat-form-field appearance="outline" class="w-full ">
          <input matInput formControlName="specification" />
          <mat-error *ngIf="submitted && f['specification'].errors?.['required']">
            Machine specification is required
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Status   Type -->
      <div class="col-span-6">
        <mat-label>Status </mat-label>

        <mat-form-field appearance="outline" class="w-full">
          <mat-select formControlName="isActive">
            <mat-option value="" disabled>Select Status Type</mat-option>
            <mat-option *ngFor="let status of statusOptions" [value]="status.id">{{ status.name }}</mat-option>
          </mat-select>
          <mat-error *ngIf="submitted && f['status'].errors?.['required']">
            Status is required
          </mat-error>
        </mat-form-field>
      </div>


    </div>

    <div>
      <button mat-raised-button color="primary" type="submit" [disabled]="!mform.valid">Save</button>
    </div>
  </div>

  <div *ngIf="false" class="bg-white rounded-xl p-6 shadow-md">

    <div class="user-group grid grid-cols-12 border-t-2 pt-4 px-6 gap-8">

      <!-- Machine Type -->
      <div class="col-span-6">
        <mat-label>Machine Type </mat-label>

        <mat-form-field appearance="outline" class="w-full">
          <mat-select formControlName="machineType">
            <mat-option value="" disabled>Select Machine Type</mat-option>
            <mat-option *ngFor="let role of statusOptions" [value]="role.id">{{ role.name }}</mat-option>
          </mat-select>
          <mat-error *ngIf="submitted && f['machineType'].errors?.['required']">
            Machine Type is required
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Machine Name -->
      <div class="col-span-6">
        <mat-label>Machine Name </mat-label>

        <mat-form-field appearance="outline" class="w-full ">
          <input matInput formControlName="machineName" />
          <mat-error *ngIf="submitted && f['machineName'].errors?.['required']">
            Machine is required
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Machine Brand -->
      <div class="col-span-6">
        <mat-label>Machine Brand </mat-label>

        <mat-form-field appearance="outline" class="w-full ">
          <input matInput formControlName="machineBrand" />
          <mat-error *ngIf="submitted && f['machineBrand'].errors?.['required']">
            Machine Brand is required
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Machine Model -->
      <div class="col-span-6">
        <mat-label>Machine Model </mat-label>

        <mat-form-field appearance="outline" class="w-full ">
          <input matInput formControlName="machineModel" />
          <mat-error *ngIf="submitted && f['machineModel'].errors?.['required']">
            Machine Model is required
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Serial Number -->
      <div class="col-span-6">
        <mat-label>Serial Number </mat-label>

        <mat-form-field appearance="outline" class="w-full ">
          <input matInput formControlName="serialNumber" />
          <mat-error *ngIf="submitted && f['serialNumber'].errors?.['required']">
            Serial Number is required
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Project  Type -->
      <div class="col-span-6">
        <mat-label>Project Type </mat-label>

        <mat-form-field appearance="outline" class="w-full">
          <mat-select formControlName="selectProject">
            <mat-option value="" disabled>Select Project Type</mat-option>
            <mat-option *ngFor="let role of statusOptions" [value]="role.id">{{ role.name }}</mat-option>
          </mat-select>
          <mat-error *ngIf="submitted && f['selectProject'].errors?.['required']">
            Project Type is required
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Status   Type -->
      <div class="col-span-6">
        <mat-label>Status </mat-label>

        <mat-form-field appearance="outline" class="w-full">
          <mat-select formControlName="status">
            <mat-option value="" disabled>Select Status Type</mat-option>
            <mat-option *ngFor="let role of statusOptions" [value]="role.id">{{ role.name }}</mat-option>
          </mat-select>
          <mat-error *ngIf="submitted && f['status'].errors?.['required']">
            Status is required
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Purchase Date -->
      <div class="col-span-6">
        <mat-label>Purchase Date </mat-label>

        <mat-form-field appearance="outline" class="w-full">
          <input matInput [max]="cValue" [matDatepicker]="startPicker" formControlName="purchaseDate" />
          <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
          <mat-error *ngIf="submitted && f['purchaseDate'].errors?.['required']">
            Purchase Date is required
          </mat-error>
        </mat-form-field>
      </div>


      <!-- Start Date -->
      <div class="col-span-6">
        <mat-label>Start Date </mat-label>

        <mat-form-field appearance="outline" class="w-full">
          <input matInput [max]="cValue" [matDatepicker]="startPicker" formControlName="startDate" />
          <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
          <mat-error *ngIf="submitted && f['startDate'].errors?.['required']">
            Start Date is required
          </mat-error>
        </mat-form-field>
      </div>

      <!-- End Date (can span full width if needed) -->
      <div class="col-span-6">
        <mat-label>End Date </mat-label>

        <mat-form-field appearance="outline" class="w-full">
          <input matInput [min]="f['startDate'].value" [matDatepicker]="endPicker"
            formControlName="endDate" />
          <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
          <mat-error *ngIf="submitted && f['endDate'].errors?.['required']">
            End Date is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="flex flex-col gap-2 md:col-span-2">
        <div class="bg-white border-2 rounded-xl border-[#0058e9]">
          <div class="p-5 flex items-center justify-center">
            <div *ngIf="!imageurl" class="w-full">
              <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM5 11.1L7 9.1L12.5 14.6L16 11.1L19 14.1V5H5V11.1ZM5 13.929V19H8.1L11.086 16.015L7 11.929L5 13.929ZM19 19H10.929L16 13.929L19 16.929V19ZM14 8.5C14 9.32843 14.6716 10 15.5 10C16.3284 10 17 9.32843 17 8.5C17 7.67157 16.3284 7 15.5 7C14.6716 7 14 7.67157 14 8.5Z"
                  fill="#525B69" />
              </svg>
            </div>
            <div class="h-30 w-40">
              <img *ngIf="imageurl" [src]="imageurl" alt="Profile Image" class="h-40 w-40" />
            </div>
          </div>
          <div class="bg-primary text-[10px] text-white py-3 px-4 rounded-b-lg py-1">
            <h1 class="text-center" style="font-size: 14px">
              Change Machine
            </h1>
          </div>
        </div>

        <div class="flex gap-4">
          <div class="flex flex-col w-full justify-end">
            <button>
              <label for="fileInput" title="File should be Jpeg, PNG and less than 3 MB"
                class="bg-primary text-white px-3 py-2 rounded-lg flex items-center cursor-pointer justify-center gap-2">
                <span class="flex">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <g clip-path="url(#clip0_1977_10834)">
                      <path d="M9 16H15V10H19L12 3L5 10H9V16ZM5 18H19V20H5V18Z" fill="#F5F5F5" />
                    </g>
                    <defs>
                      <clipPath id="clip0_1977_10834">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                Upload
              </label>
            </button>

            <input type="file" id="fileInput" title="File should be Jpeg, PNG less than 3 MB"
              (change)="handleFileInput($event)" accept=".jpg,.jpeg,.png" style="display: none" />
            <span class="tooltip">File should be Jpeg, PNG less than 3 MB</span>
          </div>

          <div *ngIf="errorMessage1" class="file-error text-[#d60000] text-[14.241px]">
            {{ errorMessage1 }}
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- <div class="w-full flex justify-end mt-4">
        <button mat-raised-button color="primary" class="w-60" (click)="onSubmit1()">Register</button>
      </div> -->
</form>



<form *ngIf="false" [formGroup]="machineForm" (ngSubmit)="onSubmitM()"
  class="p-4 grid gap-4 md:grid-cols-2  bg-white rounded-xl p-6 shadow-md">
  <div class="col-span-6">
    <mat-label>Machine Type</mat-label>

    <mat-form-field appearance="outline">
      <mat-select formControlName="machineType">
        <mat-option *ngFor="let type of machineTypes" [value]="type">{{ type }}</mat-option>
      </mat-select>
      <mat-error *ngIf="machineForm.get('machineType')?.hasError('required')">Required</mat-error>
    </mat-form-field>
  </div>
  <div class="col-span-6">
    <mat-label>Machine Make (OEM)</mat-label>

    <mat-form-field appearance="outline">
      <input matInput formControlName="make" />
      <mat-error *ngIf="machineForm.get('make')?.hasError('required')">Required</mat-error>
    </mat-form-field>
  </div>
  <div class="col-span-6">
    <mat-label>Machine Capacity (tonnes)</mat-label>

    <mat-form-field appearance="outline">
      <input matInput type="number" formControlName="capacity" />
      <mat-error *ngIf="machineForm.get('capacity')?.hasError('required')">Required</mat-error>
      <mat-error *ngIf="machineForm.get('capacity')?.hasError('min')">Must be > 0</mat-error>
    </mat-form-field>
  </div>
  <div class="col-span-6">
    <mat-label>Model Month and Year</mat-label>

    <mat-form-field appearance="outline">
      <input matInput [matDatepicker]="picker1" formControlName="modelMonthYear" />
      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
      <mat-datepicker #picker1 startView="multi-year" panelClass="month-picker"></mat-datepicker>
      <mat-error *ngIf="machineForm.get('modelMonthYear')?.hasError('required')">Required</mat-error>
    </mat-form-field>
  </div>
  <div class="col-span-6">
    <mat-label>Model Number</mat-label>

    <mat-form-field appearance="outline">
      <input matInput formControlName="modelNumber" />
      <mat-error *ngIf="machineForm.get('modelNumber')?.hasError('required')">Required</mat-error>
      <mat-error *ngIf="machineForm.get('modelNumber')?.hasError('maxlength')">Max 10 characters</mat-error>
    </mat-form-field>
  </div>
  <div class="col-span-6">
    <mat-label>Date of Commissioning</mat-label>

    <mat-form-field appearance="outline">
      <input matInput [matDatepicker]="picker2" formControlName="commissioningDate" />
      <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
      <mat-datepicker #picker2></mat-datepicker>
    </mat-form-field>
  </div>
  <div class="col-span-6">
    <mat-label>Registration Number</mat-label>

    <mat-form-field appearance="outline">
      <input matInput formControlName="registrationNumber" />
    </mat-form-field>
  </div>
  <div class="col-span-6">
    <mat-label>Serial Number</mat-label>

    <mat-form-field appearance="outline">
      <input matInput formControlName="serialNumber" />
    </mat-form-field>
  </div>
  <div class="col-span-6">
    <mat-label>Owner Reference Number</mat-label>

    <mat-form-field appearance="outline">
      <input matInput formControlName="ownerRefNumber" />
    </mat-form-field>
  </div>
  <div class="col-span-6">
    <mat-label>Soil Type vs Yield Table</mat-label>

    <mat-form-field appearance="outline" class="md:col-span-2">
      <textarea matInput rows="3" formControlName="yieldTable"></textarea>
    </mat-form-field>
  </div>
  <div class="col-span-6">
    <mat-label>Consumables Needed</mat-label>

    <mat-form-field appearance="outline" class="md:col-span-2">
      <mat-select formControlName="consumables" multiple>
        <mat-option *ngFor="let item of consumables" [value]="item">{{ item }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="col-span-6">
    <mat-label>Minor Maintenance (per NNN hours)</mat-label>

    <mat-form-field appearance="outline">
      <input matInput type="number" formControlName="minorMaintenance" />
      <mat-error *ngIf="machineForm.get('minorMaintenance')?.hasError('min')">Must be positive</mat-error>
    </mat-form-field>
  </div>
  <div class="col-span-6">
    <mat-label>Major Maintenance (per NNN hours)</mat-label>

    <mat-form-field appearance="outline">
      <input matInput type="number" formControlName="majorMaintenance" />
      <mat-error *ngIf="machineForm.get('majorMaintenance')?.hasError('min')">Must be positive</mat-error>
    </mat-form-field>
  </div>
 
  <div class="col-span-6">
    <mat-label>Machine Owner</mat-label>

    <mat-form-field appearance="outline">
      <input matInput formControlName="owner" />
    </mat-form-field>
  </div>
  <div class="col-span-6">
    <mat-label>Ownership Since</mat-label>

    <mat-form-field appearance="outline">
      <input matInput [matDatepicker]="picker3" formControlName="ownershipSince" />
      <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
      <mat-datepicker #picker3></mat-datepicker>
    </mat-form-field>
  </div>
   <div class="col-span-12">


    <div class="md:col-span-2">
      <label for="imageUpload">Upload Image</label><br>
      <input type="file" (change)="onFileChange($event)" />
    </div>
  </div>

  <button mat-raised-button color="primary" type="submit" class="md:col-span-2">Submit</button>
</form>
<mat-vertical-stepper [linear]="true" #vstepper>

  <mat-step *ngIf="false" [stepControl]="mform"> </mat-step>

  <mat-step *ngIf="false" [stepControl]="equipmentToolsForm ">
    <form [formGroup]="equipmentToolsForm" class="form-grid">
      <ng-template matStepLabel>Equipment Tools</ng-template>

      <!-- Heavy Equipment -->
      <h3>Heavy Equipment</h3>
      <div formGroupName="heavyEquipment">
        <div class="form-row">
          <div class="col-span-6">
            <mat-label>Type</mat-label>

            <mat-form-field appearance="outline" class="half-width">
              <input matInput formControlName="type" />
              <mat-error
                *ngIf="equipmentToolsForm.get('heavyEquipment.type')?.hasError('required')">Required</mat-error>
            </mat-form-field>
          </div>
          <div class="col-span-6">
            <mat-label>Make/Model</mat-label>

            <mat-form-field appearance="outline" class="half-width">
              <input matInput formControlName="makeModel" />
              <mat-error
                *ngIf="equipmentToolsForm.get('heavyEquipment.makeModel')?.hasError('required')">Required</mat-error>
            </mat-form-field>
          </div>
          <div class="col-span-6">
            <mat-label>Capacity</mat-label>

            <mat-form-field appearance="outline" class="half-width">
              <input matInput formControlName="capacity" />
              <mat-error
                *ngIf="equipmentToolsForm.get('heavyEquipment.capacity')?.hasError('required')">Required</mat-error>
            </mat-form-field>
          </div>
          <div class="col-span-6">
            <mat-label>Ownership</mat-label>

            <mat-form-field appearance="outline" class="half-width">
              <mat-select formControlName="ownership">
                <mat-option value="Owned">Owned</mat-option>
                <mat-option value="Rented">Rented</mat-option>
              </mat-select>
              <mat-error
                *ngIf="equipmentToolsForm.get('heavyEquipment.ownership')?.hasError('required')">Required</mat-error>
            </mat-form-field>
          </div>
          <div class="col-span-6">
            <mat-label>Maintenance Schedule</mat-label>

            <mat-form-field appearance="outline" class="half-width">
              <textarea matInput formControlName="maintenanceSchedule"></textarea>
              <mat-error
                *ngIf="equipmentToolsForm.get('heavyEquipment.maintenanceSchedule')?.hasError('required')">Required</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Testing Equipment -->
      <h3>Testing Equipment</h3>
      <div formGroupName="testingEquipment">
        <div class="form-row">
          <div class="col-span-6">
            <mat-label>Type</mat-label>

            <mat-form-field appearance="outline" class="half-width">
              <input matInput formControlName="type" />
              <mat-error
                *ngIf="equipmentToolsForm.get('testingEquipment.type')?.hasError('required')">Required</mat-error>
            </mat-form-field>
          </div>
          <div class="col-span-6">
            <mat-label>Calibration Status</mat-label>

            <mat-form-field appearance="outline" class="half-width">
              <input matInput formControlName="calibrationStatus" />
              <mat-error
                *ngIf="equipmentToolsForm.get('testingEquipment.calibrationStatus')?.hasError('required')">Required</mat-error>
            </mat-form-field>
          </div>
          <div class="col-span-6">
            <mat-label>Laboratory Certification</mat-label>

            <mat-form-field appearance="outline" class="half-width">
              <textarea matInput formControlName="labCertification"></textarea>
              <mat-error
                *ngIf="equipmentToolsForm.get('testingEquipment.labCertification')?.hasError('required')">Required</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Tools Inventory -->
      <h3>Tools Inventory</h3>
      <div formGroupName="toolsInventory">
        <div class="form-row">
          <div class="col-span-6">
            <mat-label>Type and Quantity</mat-label>

            <mat-form-field appearance="outline" class="half-width">
              <input matInput formControlName="typeQuantity" />
              <mat-error
                *ngIf="equipmentToolsForm.get('toolsInventory.typeQuantity')?.hasError('required')">Required</mat-error>
            </mat-form-field>
          </div>
          <div class="col-span-6">
            <mat-label>Condition</mat-label>

            <mat-form-field appearance="outline" class="half-width">
              <input matInput formControlName="condition" />
              <mat-error
                *ngIf="equipmentToolsForm.get('toolsInventory.condition')?.hasError('required')">Required</mat-error>
            </mat-form-field>
          </div>
          <div class="col-span-6">
            <mat-label>Replacement Schedule</mat-label>

            <mat-form-field appearance="outline" class="half-width">
              <textarea matInput formControlName="replacementSchedule"></textarea>
              <mat-error
                *ngIf="equipmentToolsForm.get('toolsInventory.replacementSchedule')?.hasError('required')">Required</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="form-actions">
        <button mat-button matStepperPrevious>Back</button>
        <button mat-raised-button color="primary" matStepperNext [disabled]="!equipmentToolsForm.valid">Next</button>

      </div>


    </form>

  </mat-step>
</mat-vertical-stepper>